/* PGN perf 02/10 (corte 1): foto de hover dos cards sob demanda.
   snippets/card-product.liquid entrega a 2a foto do card (img[data-pgn-hover]) com data-src/data-srcset.
   - Toque: nunca baixa (pointerover com pointerType touch e ignorado).
   - Mouse ou caneta: baixa no 1o pointerover do card, em qualquer aparelho (inclusive iPad com trackpad e
     notebook com tela de toque, onde o (hover: hover) e falso).
   - Onde o mouse fino e a entrada principal: alem disso, depois do load + tempo ocioso, em lotes de 4.
     O loading="lazy" da tag continua valendo: card longe da tela so baixa quando chega perto, como antes.
   - O data-srcset so sai no load da foto. Ate la, a guarda do component-card.css mantem a foto 1 no hover.
   - Cards que entram depois (filtro/paginacao/relacionados por AJAX): o pointerover e delegado no document
     e o MutationObserver so le addedNodes. Ele nao observa atributos e nao reescreve no nenhum. */
(function () {
  var P = 'img[data-pgn-hover][data-srcset]', Q = P + ':not([data-pgn-armed])', M = 1250, busy = false;

  function arm(img, cb) {
    var o = { once: true };
    img.setAttribute('data-pgn-armed', '');
    img.addEventListener('load', function () { img.removeAttribute('data-srcset'); if (cb) cb(); }, o);
    img.addEventListener('error', function () { if (cb) cb(); }, o);
    img.srcset = img.getAttribute('data-srcset');
    img.src = img.getAttribute('data-src');
  }

  /* (a) primeiro hover de mouse/caneta no card: baixa ja, se ainda nao baixou */
  document.addEventListener('pointerover', function (e) {
    var c = e.pointerType != 'touch' && e.target.closest && e.target.closest('.card-wrapper');
    var img = c && c.querySelector(P);
    if (!img) return;
    if (!img.hasAttribute('data-pgn-armed')) arm(img);
    else if (img.complete && img.naturalWidth) img.removeAttribute('data-srcset'); /* copia clonada ja carregada */
  }, { passive: true });

  /* (b) so onde o mouse fino e a entrada principal */
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var idle = window.requestIdleCallback
    ? function (f) { requestIdleCallback(f, { timeout: 2000 }); }
    : function (f) { setTimeout(f, 1500); };

  /* depois do load, no tempo ocioso: 4 por vez; espera so as que estao perto da tela (no maximo 3 s) */
  function lote() {
    var l = document.querySelectorAll(Q), n = Math.min(l.length, 4), w = 0, foi = false, i, r;
    if (!n) { busy = false; return; }
    function segue() { if (!foi) { foi = true; idle(lote); } }
    function um() { if (--w <= 0) segue(); }
    for (i = 0; i < n; i++) {
      r = l[i].getBoundingClientRect();
      if (r.width && r.bottom > -M && r.top < innerHeight + M && r.right > -M && r.left < innerWidth + M) {
        w++;
        arm(l[i], um);
      } else {
        arm(l[i]);
      }
    }
    if (w) setTimeout(segue, 3000); else segue();
  }

  function vai() { if (!busy) { busy = true; idle(lote); } }

  function comeca() {
    vai();
    if (!window.MutationObserver) return;
    new MutationObserver(function (rs) {
      for (var i = 0; i < rs.length; i++) {
        for (var j = 0, a = rs[i].addedNodes; j < a.length; j++) {
          if (a[j].nodeType == 1 && (a[j].matches(Q) || a[j].querySelector(Q))) return vai();
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState == 'complete') comeca();
  else window.addEventListener('load', comeca);
})();
